interface TradeActionsModel {
  sell: string;
  buy: string;
}

export const TRADE_ACTIONS: TradeActionsModel = {
  sell: 'sell',
  buy: 'buy'
}
